import { render, staticRenderFns } from "./storeSwitchIdentity.vue?vue&type=template&id=0cdafe96&scoped=true&"
import script from "./storeSwitchIdentity.vue?vue&type=script&lang=babel&"
export * from "./storeSwitchIdentity.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdafe96",
  null
  
)

export default component.exports